import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../firebase";

const GetAllClasses = async (SchoolID) => {
  try {
    const ClassesCollection = await collection(db, "Classes");

    const q = query(
      ClassesCollection,
      where("SchoolID", "==", SchoolID),
      where("IsDeleted", "==", false)
    );
    const ClassesSnapshot = await getDocs(q);

    let ClassesData = [];

    ClassesSnapshot.forEach((doc) => {
      ClassesData.push({ ...doc.data(), id: doc.id });
    });
    return ClassesData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllClasses;
